export default __webpack_public_path__ + "static/topImg-f895e849b20fd5faa8fcb097527b3fe7.jpg";